
import React, { useState } from 'react'
import SEO from '@/templates/seo'

function SearchSeoComponent(props: any) {
  const { selectedWords, suggests, keyword, pathname, products, total } = props || {}
  const [_keywords] = useState(() => {
    const keywords = new Set()
    selectedWords?.slice(0, 3)?.forEach((k: string) => {
      if (k !== keyword) {
        keywords.add(k)
      }
    })
    if (keywords.size < 3) {
      suggests?.slice(0, 3)?.forEach((s: any) => {
        if (s.keyword !== keyword) {
          keywords.add(s.keyword)
        }
      })
    }
    if (keywords.size === 0) {
      keywords.add(keyword)
    }
    return Array.from(keywords)
  })

  return (
    <SEO
      title={`${keyword?.trim() ? `[${keyword}]` : ''}价格_正品_品牌_海淘 | 别样海外购`}
      description={`别样海外购${keyword}海淘频道,别样提供${total > 0 ? `超过${total}件` : ''}${keyword?.trim()? keyword : ''}正品商品,${_keywords.join(',')}价格折扣,尺码和优惠等信息,促销海外直购一手货源,网购奢品大牌正品直达`}
      keywords={`别样海外购,${keyword},${_keywords.join(',')},别样App`}
      canonical={pathname ? `https://www.bieyangapp.com/browse/${pathname}/` : undefined}
      image={products?.length ? (products?.[0]?.searchProduct?.product?.images?.[0]?.thumbnail?.url || products?.[0]?.searchProduct?.product?.images?.[0]?.full?.url) : undefined}
    />
  )
}

export default SearchSeoComponent
